import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useEntityProgress } from "reactcoregk/hooks";
import { addTableSettings } from "../../store/userSettings/actions";
import BaseDialog from "./BaseDialog";
import React from "react";

function TableSettingsDialog(props) {
  const {
    open,
    handleClose,
    context,
    storedCells,
    defaultCells,
    tableKey,
    addTableSettings,
    isLocal = false,
    setSelectedColumnKeys,
    setActiveHeadCellsForLocalTable,
  } = props;
  const [busy, error] = useEntityProgress(context.UserSettings, handleClose);

  const [selectedCells, setSelectedCells] = useState(storedCells);

  const numSelected = selectedCells.length;
  const rowCount = defaultCells.length;

  useEffect(() => {
    if (open) {
      if (storedCells.length > 0) {
        setSelectedCells(storedCells);
      } else {
        const mapped = defaultCells.filter((x) => x.default).map((x) => x.id);
        setSelectedCells(mapped);
      }
    }
  }, [defaultCells, open, storedCells]);

  const handleCheck = (prop) => (e) => {
    const value = e.target.checked;
    if (value) {
      setSelectedCells((prevState) => [...prevState, prop]);
    } else {
      setSelectedCells((prevState) => prevState.filter((x) => x !== prop));
    }
  };

  const handleCheckAll = () => {
    const mapped = defaultCells.map((x) => x.id);
    setSelectedCells(numSelected < rowCount ? mapped : []);
  };

  const handleNewCells = () => {
    if (isLocal) {
      setSelectedColumnKeys(selectedCells);
      setActiveHeadCellsForLocalTable(
        defaultCells?.filter((cell) => selectedCells.includes(cell?.id))
      );
      handleClose();
    } else {
      addTableSettings({
        key: tableKey,
        value: selectedCells,
      });
    }
  };

  return (
    <BaseDialog
      onClose={handleClose}
      open={open}
      title={"Customize List View"}
      showProgress
      primaryAction={handleNewCells}
      inProgress={busy}
      isLoading={busy}
      isValid={numSelected > 0}
      errorMessage={error}
    >
      <Grid container direction={"column"} style={{ maxWidth: 470 }}>
        <Grid item>
          <FormControlLabel
            disabled={busy}
            control={
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={handleCheckAll}
                inputProps={{ "aria-label": "select all columns" }}
              />
            }
            label={"All"}
          />
        </Grid>
        {defaultCells.map((cell, key) => {
          const checked = selectedCells.includes(cell.id);
          return (
            <Grid item key={key}>
              <FormControlLabel
                disabled={busy}
                control={
                  <Checkbox
                    onChange={handleCheck(cell.id)}
                    checked={checked}
                    color="primary"
                  />
                }
                label={cell.label}
              />
            </Grid>
          );
        })}
      </Grid>
    </BaseDialog>
  );
}

const mapStateToProps = (state) => {
  return {
    context: state,
  };
};
export default connect(mapStateToProps, { addTableSettings })(
  TableSettingsDialog
);

TableSettingsDialog.propTypes = {
  storedCells: PropTypes.array.isRequired,
  defaultCells: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  tableKey: PropTypes.string.isRequired,
  context: PropTypes.any,
  addTableSettings: PropTypes.func,
};
